module.exports = __webpack_public_path__ + "img/build.7fdf3a31.png";